'use strict';

define('composer/formatting', ['quill', 'bootbox'], function (Quill, bootbox) {
	const formatting = {};

	function getYouTubeUrl(url) {
		const match = url.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtube\.com\/watch.*v=([a-zA-Z0-9_-]+)/) ||
				url.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtube\.com\/shorts\/([a-zA-Z0-9_-]+)/) ||
        url.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtu\.be\/([a-zA-Z0-9_-]+)/) ||
        url.match(/^.*(youtu.be\/|v\/|e\/|u\/\w+\/|embed\/|v=)([^#&?]*).*/);

		if (match && match[2].length === 11) {
			return {
				id: match[2],
				url: `https://www.youtube.com/embed/${match[2]}?showinfo=0`,
			};
		}
		// if (match = url.match(/^(?:(https?):\/\/)?(?:www\.)?vimeo\.com\/(\d+)/)) { // eslint-disable-line no-cond-assign
		// return (match[1] || 'https') + '://player.vimeo.com/video/' + match[2] + '/';
		// }
		return null;
	}

	function quillInsert(quill, fn, ...args) {
		const originLength = quill.getLength();
		let rangeIndex = quill.selection.savedRange.index;
		if (typeof quill[fn] === 'function') {
			quill[fn].call(quill, rangeIndex, ...args);
		}
		const currentLength = quill.getLength();
		rangeIndex += currentLength - originLength;
		quill.setSelection(rangeIndex);
	}

	function showAlert(message) {
		app.alert({
			alert_id: 'action:composer.upload',
			title: '',
			message,
			timeout: 2000,
		});
	}

	formatting.dialog = {
		video: (callback) => {
			window.__composer_prompt__ = bootbox.prompt({
				title: 'Please Enter YouTube Link',
				closeButton: false,
				className: 'aidot-composer-modal',
				buttons: {
					cancel: { label: 'Cancel' },
					confirm: { label: 'Confirm' },
				},
				callback: (url) => {
					if (url) {
						const videoUrl = getYouTubeUrl(url);
						if (videoUrl) {
							if (typeof callback === 'function') {
								callback(videoUrl);
							}
						} else {
							showAlert('Please enter the YouTube link!');
							return false;
						}
					}
				},
			});
		},
		link: (...args) => {
			const values = {
				text: '',
				url: '',
			};
			let callback;

			if (args.length === 0) {
				throw new Error('[formatting.dialog] params is required on link function.');
			} else {
				args.forEach((arg) => {
					if (typeof arg === 'function' && !callback) {
						callback = arg;
					} else if (typeof arg === 'object' && arg.url) {
						values.url = arg.url;
						values.text = arg.text;
					}
				});
			}

			const form = document.createElement('form');
			const inputAttrs = 'class="bootbox-input bootbox-input-text form-control" autocomplete="off" type="text"';
			form.innerHTML =
				`<input ${inputAttrs} name="url" value="${values.url}" placeholder="Please enter link address">` +
				'<br>' +
				`<input ${inputAttrs} name="text" value="${values.text}" placeholder="Please enter link text (optional)">`;
			window.__composer_prompt__ = bootbox.dialog({
				closeButton: false,
				title: 'Insert Link',
				className: 'aidot-composer-modal',
				size: 'large',
				message: form,
				buttons: {
					cancel: {
						label: 'Cancel',
						className: 'btn-secondary btn-default',
					},
					comfirm: {
						label: 'Comfirm',
						className: 'btn-primary',
						callback: function () {
							const f = new FormData(form);
							const url = f.get('url');
							const text = f.get('text');
							if (!url) {
								showAlert('Please enter link address!');
								return false;
							} else if (!/^https?:\/\//i.test(url)) {
								showAlert("The URL should start with 'http://' or 'https://'.");
								return false;
							}
							if (typeof callback === 'function') {
								return callback(url, text);
							}
							return true;
						},
					},
				},
			});
		},
	};

	const formattingDispatchTable = {
		picture: function () {
			var postContainer = this;
			const attr = postContainer[0].attributes;
			const ismoment = attr.ismoment.value === 'true';
			// const isforum = attr.isforum.value === 'true';
			const isreplay = attr.isreplay.value === 'true';

			// png,jpg,bmp,mp4,quicktime
			let accept = 'image/png, image/jpeg, image/bmp';
			if (ismoment && postContainer.find('.img-item').length) {
				accept = 'image/png, image/jpeg, image/bmp';
			} else if (!isreplay) {
				accept += ', video/mp4, video/quicktime';
			}
			postContainer.find('#files').attr('accept', accept).click();
		},

		video: function (quill) {
			const $container = this;
			const videoCount = $container.find('.ql-video').length;
			if (videoCount >= 3) {
				showAlert('Only three video available.');
			} else {
				formatting.dialog.video((videoUrl) => {
					const id = videoUrl.id;
					if (quill) {
						// forum
						quillInsert(quill, 'insertEmbed', 'OnlineVideo', { id, src: videoUrl.url });
						if (formatting.onComposerUploaded) {
							formatting.onComposerUploaded({
								post_uuid: $container.data('uuid'),
								files: [{
									id: videoUrl.id,
									url: videoUrl.url,
									isOnlineVideo: true,
								}],
							});
						}
					} else {
						// moment
						$container.find('#uploadImage').prop('disabled', true).attr('disabled', true);
						const videos = $container.find('.video-container');
						videos.removeClass('hidden').find('.iframely-container').remove();
						videos.append(`<div class="iframely-container"><div class="iframely-container__inner"><iframe class="ql-video" src="${videoUrl.url}" allowfullscreen></iframe></div></div>`);

						if (formatting.onComposerUploaded) {
							formatting.onComposerUploaded({
								post_uuid: $container.data('uuid'),
								videoList: [{
									id: videoUrl.id,
									url: videoUrl.url,
									isOnlineVideo: true,
								}],
							});
						}
					}
				});
			}
		},

		link: function (quill) {
			if (quill) {
				formatting.dialog.link((url, text) => {
					quillInsert(quill, 'insertText', text || url, 'link', url);
				});
			}
		},
	};

	formatting.getDispatchTable = function () {
		return formattingDispatchTable;
	};

	formatting.addButtonDispatch = function (name, onClick) {
		formattingDispatchTable[name] = onClick;
	};

	formatting.addHandler = function (postContainer, onComposerUploaded) {
		formatting.onComposerUploaded = onComposerUploaded;
		postContainer.on('click', '.function-container .f-item[data-format]', function (e) {
			if (this.hasAttribute('disabled')) {
				return;
			}
			const format = $(this).data('format');
			if (format && formattingDispatchTable.hasOwnProperty(format)) {
				e.preventDefault();
				const quill = postContainer.find('.ql-container').data('quill');
				formattingDispatchTable[format].call(postContainer, quill);
			}
		});
	};

	return formatting;
});
